import { createAction } from '../../../../store.model';
import { CaResult } from '../../core';
import { ActionType } from '../ca-analysis-dialog.action';

export interface ReceiveResultData {
    caResult: CaResult;
}

export const receiveResultData = createAction<ActionType, ReceiveResultData>(
    ActionType.COACHING__CA__RECEIVE_RESULT_DATA,
);
